import type { EmployeeInput } from '@vivaldis/graphql'
import { format } from 'date-fns'
import type { EditEmployeeProfileFormValues } from '../provider/FormProvider'

export const employeeFormValuesToEmployeeInput = (
  values: EditEmployeeProfileFormValues
): EmployeeInput => {
  return {
    isStudent: values.isStudent,
    workProfile: {
      taxCode: values.taxCode,
      maritalState: values.maritalState || undefined,
      maritalDate: values.maritalDate
        ? format(values.maritalDate, 'yyyy-MM-dd')
        : null,
      childrenNumber: values.childrenNumber,
      childrenWithDisabilitiesNumber: values.childrenWithDisabilitiesNumber,
      dependentPersonsNumber: values.dependentPersonsNumber,
      dependentPersonsWithDisabilitiesNumber:
        values.dependentPersonsWithDisabilitiesNumber,
      involuntaryPartTime: values.involuntaryPartTime
    }
  }
}
